import React from "react";
import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import routes from "../routes/main";
import pagesStyle from "../assets/jss/material-dashboard-pro-react/layouts/authStyle.jsx";

class Pages extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "unset";
  }

  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.isAuth) {
        return (
          <Route path={prop.path} component={prop.childComponent} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  // getBgImage = () => {
  //   if (
  //     typeof window !== "undefined" &&
  //     window.location.pathname.indexOf("/") !== -1
  //   ) {
  //     return login;
  //   }
  // };

  getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          typeof window !== "undefined" &&
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.wrapper} ref="wrapper">
          <div
            className={classes.fullPage}
            style={{ backgroundColor: "#223B8C" }}
          >
            <Switch>{this.getRoutes(routes)}</Switch>
          </div>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(pagesStyle)(Pages);
